$(function() {
    // Handler for clicking on the links in li.hasmenu
    $(document).on("click", "li.hasmenu > a", function(e) {
        e.preventDefault(); // Prevent the default anchor click behavior

        var $parentLi = $(this).parent();

        // Toggle the "open" class based on its presence
        if ($parentLi.hasClass("open")) {
            $parentLi.removeClass("open");
        } else {
            $("li.hasmenu").removeClass("open"); // Remove "open" from other li.hasmenu
            $parentLi.addClass("open"); // Add "open" to the clicked li.hasmenu
        }
    });

    // Handler for clicking anywhere else in the document
    $(document).on("click", function(e) {
        // Check if the clicked area is outside of li.hasmenu
        if (!$(e.target).closest("li.hasmenu").length) {
            $("li.hasmenu").removeClass("open"); // Remove "open" from all li.hasmenu
        }
    });
});
